export const APP_NAME = "CCCV Community";
export const HELP_EMAIL = "help@cccvcommunity.org";
export const TERMS_REVISED_DATE = new Date("20 Dec 2018");
export const PRIVACY_REVISED_DATE = new Date("20 Dec 2018");
